import { type StateCreator } from 'zustand';

export enum LibrarySortBy {
  Title = 'title',
  CreatedAt = 'createdAt',
  Pos = 'pos',
  CustomSort = 'customSort',
}

export enum LibrarySortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export type LibrarySortSlice = {
  librarySortBy: LibrarySortBy;
  librarySortDirection: LibrarySortDirection;
  resetLibrarySort: () => void;
  resetLibrarySortBy: () => void;
  resetLibrarySortDirection: () => void;
  setLibrarySortBy: (sortBy: LibrarySortBy) => void;
  setLibrarySortDirection: (sortDirection: LibrarySortDirection) => void;
};

export type CreateLibrarySortSlice = (
  initialState: Pick<Partial<LibrarySortSlice>, 'librarySortBy' | 'librarySortDirection'>,
) => StateCreator<LibrarySortSlice, [], [], LibrarySortSlice>;

export const createLibrarySortSlice: CreateLibrarySortSlice = (initialState) => (set) => ({
  librarySortBy: initialState.librarySortBy ?? LibrarySortBy.Title,
  librarySortDirection: initialState.librarySortDirection ?? LibrarySortDirection.Asc,
  resetLibrarySort: () =>
    set({
      librarySortBy: initialState.librarySortBy ?? LibrarySortBy.Title,
      librarySortDirection: initialState.librarySortDirection ?? LibrarySortDirection.Asc,
    }),
  resetLibrarySortBy: () => set({ librarySortBy: initialState.librarySortBy ?? LibrarySortBy.Title }),
  resetLibrarySortDirection: () =>
    set({ librarySortDirection: initialState.librarySortDirection ?? LibrarySortDirection.Asc }),
  setLibrarySortBy: (sortBy) => set({ librarySortBy: sortBy }),
  setLibrarySortDirection: (sortDirection) => set({ librarySortDirection: sortDirection }),
});
